import axios from 'axios';
import axiosConfig from '@/config/axios';
// import data from './cursos.json';

// indoacademy (Moodle) se autentica con el wstoken de la URL; NO debe recibir el
// header Authorization Bearer de la app (rompe la llamada). Usamos una instancia
// propia sin ese header y que no pasa por los interceptors globales de axios.
const moodleClient = axios.create();
delete moodleClient.defaults.headers.common.Authorization;

function moodleGet(query) {
  return moodleClient.get(
    `${axiosConfig.moodleRestURL}?wstoken=${axiosConfig.moodleToken}&moodlewsrestformat=json&${query}`,
    {
      headers: {
        ...axiosConfig.headersOfertas,
      },
    },
  );
}

export default {
  cursos() {
    // return data;
    return moodleGet('wsfunction=core_course_get_courses');
  },
  cursosPorCategoria(categoryId) {
    return moodleGet(
      `wsfunction=core_course_get_courses_by_field&field=category&value=${categoryId}`,
    );
  },
  contenidosCurso(courseId) {
    return moodleGet(`wsfunction=core_course_get_contents&courseid=${courseId}`);
  },
  curso(curso_id) {
    // return data;
    return moodleGet(
      `wsfunction=core_course_get_courses_by_field&field=id&value=${curso_id}`,
    );
  },
};
